// extracted by mini-css-extract-plugin
export default {"resizeHandle":"TableHeader_resizeHandle__q1Z-5"};